import './App.css';
import ModuleRoutes from "./components/routes";
import {SnackbarProvider} from "notistack";
import {useEffect} from "react";
import i18n from "i18next";
import {useDynamicFont} from "./shared/hooks/font-hooks";
import "./dayjs-jalali-setup";

const App = () => {

    useEffect(() => {
        const lang = localStorage.getItem('language') || 'fa';
        i18n.changeLanguage(lang);
        document.dir = lang === 'fa' || lang === 'ar' ? 'rtl' : 'ltr';
    }, []);

    useDynamicFont()
    return (
        <ModuleRoutes/>
    );
}

export default App;
